import React from 'react';

import { RichTextField } from '../RichTextField/RichTextField';
import { ModalFragment } from '../../../graphql.schema';
import { ModalRawHTML } from '../RawHTML/ModalRawHTML';
import ModalFadeInCenter from '../ModalFadeInCenter';
import ContactForm from '../ContactForm';

import * as styles from './HubspotModal.module.scss';

type Props = ModalFragment & { isOpen: boolean; onClose: () => unknown };
export const HubspotModal = (props: Props) => {
  return (
    <ModalFadeInCenter canClose isOpen={props.isOpen} onRequestClose={props.onClose} shouldCloseOnOverlayClick={false}>
      {props?.websiteLocale?.locale !== 'he-IL' || props?.websiteLocale?.locale !== 'ar-IL' ? <div className={styles.heading}>
        <h3 className="title is-3">{props.title}</h3>
        <RichTextField content={props.description} />
      </div> : <></>}
      {/* TODO - Remove the code after testing in this API in dev environment */}
      {props?.websiteLocale?.locale == 'he-IL' || props?.websiteLocale?.locale == 'ar-IL' ? <ContactForm
        title={{ id: 'contact-title', defaultMessage: 'Contct Us' }}
        text={{ id: 'contact-text', defaultMessage: 'Complete the form and our staff will contact you.' }}
        checkBox={{
          label: { id: 'contact-checkbox', defaultMessage: 'I agree to receive educational and/or marketing information via email or SMS' },
          name: 'sms', placeholder: { id: 'contact-sms', defaultMessage: 'sms' }, type: 'checkbox', required: false
        }}
        fullInputs={[
          { label: { id: 'contact-full-name', defaultMessage: 'Full Name' }, name: 'FullName', placeholder: { id: 'contact-full-name', defaultMessage: 'Fullname' }, type: 'text', required: true },
          { label: { id: 'contact-phone', defaultMessage: 'Phone' }, name: 'phone', placeholder: { id: 'contact-phone-placeholder', defaultMessage: 'Phone' }, type: 'text', pattern: '05[0-9]{8}', required: true },
        ]} /> :
        <ModalRawHTML className={styles.wrapper} html={props.html} isModal={true} />}
    </ModalFadeInCenter>
  );
};
